import React from "react"
import PropTypes from "prop-types"
import cx from "classnames"
import "./checkbox.css"

function Checkbox({
  className,
  style,
  color,
  strikeThrough = false,
  ...props
}) {
  const classNames = cx(
    className,
    "design-custom-box",
    "design-checkbox",
    "text-base",
    "flex-shrink-0",
    "shrink-0"
  )
  const colors = {
    blue: "var(--blue-500)",
    red: "var(--red-500)",
    "dark-gray": "var(--gray-800)"
  }
  const styleOverride =
    color && color !== "green"
      ? {
          "--active-checkbox": colors[color]
        }
      : null

  if (strikeThrough) {
    return (
      <div className="relative inline-block w-5 h-5 ">
        <input
          className={classNames}
          style={{
            ...styleOverride,
            ...style,
            "--border": colors[color],
            borderWidth: "2px"
          }}
          type="checkbox"
          {...props}
        />
        <span
          className="absolute checkbox-strike-through"
          style={{
            backgroundColor: colors[color]
          }}
        />
      </div>
    )
  }

  return (
    <input
      className={classNames}
      style={{ ...styleOverride, ...style }}
      type="checkbox"
      {...props}
    />
  )
}

Checkbox.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  color: PropTypes.oneOf(["green", "blue", "red", "dark-gray"]),
  strikeThrough: PropTypes.bool
}

export default Checkbox
